import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_APP016_Request, IAPI_FAC002_Request } from "../../type/apiType";
import "./_style.scss";
import { httpIAPI_APP016, httpIAPI_FAC002 } from "./api/request";
import { funInfoBodyList, funMemoBodyList } from "./hooks/useHooks";
import { headTitleList, memoTitleList } from "./parts";
import TkMemo from "../../components/molecules/TkMemo";
import { InquiryCode } from "../../assets/data/Constants";

/**
 * SCRW050008 廃止・休止・経営移管施設内容確認
 * @return SCRW050008 廃止・休止・経営移管施設内容確認
 */
const SCRW050008 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const [memoCheck, setMemoCheck] = useState(false);
  const [memoData, setMemoData] = useState("");
  const [textData, setTextData] = useState<any>();
  const [bodyListData, setBodyListData] = useState<any>();
  const [memoList, setMemoList] = useState<any>([]);
  const [statusData, setStatusData] = useState<any>();
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>();

  const btnEvent = async (btnName: any) => {
    let numData = "";
    switch (btnName) {
      case "契約者に差戻し":
        numData = "5";
        break;
      case "受理":
        numData = "2";
        break;
      case "担当者に差戻し":
        numData = "8";
        break;
      case "課長代理確認":
        numData = "14";
        break;
      case "上長承認":
        numData = "6";
        break;
    }

    let reqData: IAPI_APP016_Request = {
      applyId: location.state?.applyId!,
      applyEvent: numData,
      contractorNo: businessState.common?.contractorNo,
      inquiryCode: memoCheck ? InquiryCode["施設"] : "",
      screenId: "SCRW050008",
      reason: memoData,
    };

    try {
      const res = await httpIAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  const handleInit = async () => {
    let reqData: IAPI_FAC002_Request = {
      applyId: location.state.applyId!,
    };
    try {
      const res = await httpIAPI_FAC002({
        ...reqData,
      });
      if (res.resultCd === "I0000") {
        setBodyListData(funInfoBodyList(res.facilityList, res.formList));
        setMemoList(funMemoBodyList(res.statusList));
        setStatusData(res.latestApplyStatus);
        setCorpApplyKbn(res.corpApplyKbn);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    const text =
      (businessState?.common?.contractorNo ?? "") +
      ":" +
      (businessState?.common?.contractorName ?? "");
    setTextData(text);
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="SCRW050008" data-testid="SCRW050008PageForTest">
      <Box>
        <TkKikoStepper
          applicationFlowType="TYPE3"
          businessType="JOB-18"
          applicationStatus={statusData}
          corporateApplicationClassification={corpApplyKbn}
        />
      </Box>
      <Box className="SCRW050008InfoManual">
        {/* TkInfoManualを表示 */}
        <TkInfoManual rule={"\\n"}>
          {labelids.labelid.LBLW050008_01}
        </TkInfoManual>
      </Box>
      <TkContractorAndNumberLine name={"契約者（法人）名"} no={textData} />
      <Box>
        <TkTable
          headList={headTitleList}
          bodyList={bodyListData}
          pagin={true}
        ></TkTable>
      </Box>
      <TkMemo
        data-testid="SCRW050008memo"
        showTable={true}
        headList={memoTitleList}
        bodyList={memoList}
        onChange={onChange}
        disabledCheckBox={false}
      ></TkMemo>
      <Box className="btn">
        <TkBackButton className="back"></TkBackButton>
        <TkViewButtonJudgement
          flowType={"TYPE3"}
          Status={statusData}
          onClick={btnEvent}
          data-testid="TkViewButtonJudgement"
        />
      </Box>
    </Box>
  );
};

export default SCRW050008;
